import { useEffect, useState } from 'react';

/** A typed value that settles after `ms` without a new keystroke — the screens re-read on the settled value (never per key). */
export function useDebounced<T>(value: T, ms: number): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = globalThis.setTimeout(() => setSettled(value), ms);
    return () => globalThis.clearTimeout(timer);
  }, [value, ms]);
  return settled;
}
